'use client';

import React from "react";
import ProductOptionComponent from "@/app/components/product/product_options";
import useConfigValue from "@/utils/config";

interface ProductOptionsIslandProps {
    productVariants: any;
    productId: string;
    selectedSize?: string;
}

/**
 * Client island for product variant options (color, size, fabric, etc.).
 * Needs useConfigValue hook which requires client context.
 */
const ProductOptionsIsland: React.FC<ProductOptionsIslandProps> = ({
    productVariants,
    productId,
    selectedSize,
}) => {
    const optionsStyling = useConfigValue('PRODUCT_OPTIONS') as any;

    if (!productVariants) return null;

    return (
        <>
            {Object.keys(productVariants).map((key: string) => (
                <React.Fragment key={key}>
                    {productVariants[key].data.length > 0 && (
                        <ProductOptionComponent {...{
                            page: "pdp",
                            type: optionsStyling[key] ? optionsStyling[key].variation : optionsStyling['default-config'].variation,
                            selectedProductId: productId,
                            option: productVariants[key],
                            selectedSize: selectedSize,
                        }} />
                    )}
                </React.Fragment>
            ))}
        </>
    );
};

export default ProductOptionsIsland;
